import Composite from "./sidebar/composite";

type Options = {
    contentSelector: string;
    toggleSelector: string;
    containerSelector: string;
    classNameOpen?: string;
    classNameClosed?: string;
    classNameChanged?: string;
    classNameDisabled?: string;
    // TODO: Find native way in ts for converting css `calc()` & `clamp()` values to pixels/number (see `this.mayToggle()`)
    // styleValueContentSize?: string;
    // styleValueBlockGap?: string;
}

const defaultOptions: Options = {
    contentSelector: null,
    toggleSelector: null,
    containerSelector: null,
    classNameOpen: 'is-open',
    classNameClosed: 'is-closed',
    classNameChanged: 'is-changed',
    classNameDisabled: 'is-disabled',
    // styleValueContentSize: '--wp--style--global--content-size',
    // styleValueBlockGap: '--wp--style--block-gap',
}

class Sidebar {
    constructor(private readonly el: HTMLElement, private options: Options = defaultOptions) {
        this.el = el;
        this.options = {
            ...defaultOptions,
            ...options,
        };

        new Composite(this.el);

        this.init();
    }

    public init(): void {
        this.el.addEventListener('enable', this.onEnable.bind(this));
        this.el.addEventListener('disable', this.onDisable.bind(this));
        this.el.addEventListener('change', this.onChanging.bind(this));
        this.el.addEventListener('animationend', this.onChanged.bind(this));
        this.el.addEventListener('click', this.onToggle.bind(this));
        document.addEventListener('click', this.onOuter.bind(this));
        window.addEventListener('resize', this.onInit.bind(this));
        window.dispatchEvent(new Event('resize'));
    }

    public enable(): void {
        if (!this.el.classList.contains(this.options.classNameDisabled)) {
            return;
        }

        this.el.classList.remove(this.options.classNameDisabled);
    }

    public disable(): void {
        if (this.el.classList.contains(this.options.classNameDisabled)) {
            return;
        }

        this.el.classList.add(this.options.classNameDisabled);
    }

    public toggle(): void {
        if (this.el.classList.contains(this.options.classNameOpen)) {
            this.close();
        } else {
            this.open();
        }
    }

    public open(): void {
        if (this.el.classList.contains(this.options.classNameOpen)) {
            return;
        }

        this.el.classList.remove(this.options.classNameClosed);
        this.el.classList.add(this.options.classNameOpen);
    }

    public close(): void {
        if (this.el.classList.contains(this.options.classNameClosed)) {
            return;
        }

        this.el.classList.remove(this.options.classNameOpen);
        this.el.classList.add(this.options.classNameClosed);
    }

    public changing(): void {
        this.el.classList.add(this.options.classNameChanged);
    }

    public changed(): void {
        this.el.classList.remove(this.options.classNameChanged);
    }

    private async onInit(event: UIEvent): Promise<void> {
        if (this.hasSpace()) {
            this.open();
        } else {
            this.close();
        }
    }

    private async onEnable(event: Event): Promise<void> {
        this.enable();
    }

    private async onDisable(event: Event): Promise<void> {
        this.disable();
    }

    private async onChanging(event: Event): Promise<void> {
        this.changing();
    }

    private async onChanged(event: Event): Promise<void> {
        this.changed();
    }

    private async onToggle(event: MouseEvent): Promise<void> {
        if (!(event.target as HTMLElement).closest(this.options.toggleSelector)) {
            return;
        }

        this.toggle();
    }

    private async onOuter(event: MouseEvent): Promise<void> {
        if (this.el.contains(event.target as HTMLElement)) {
            return;
        }

        if (this.hasSpace()) {
            return;
        }

        this.close();
    }

    private hasSpace(): boolean {
        const windowSize = window.innerWidth,
            contentSize = (document.querySelector(this.options.contentSelector) as HTMLElement).offsetWidth,
            containerSize = (this.el.querySelector(this.options.containerSelector) as HTMLElement).offsetWidth
            // styleValueContentSize = window.getComputedStyle(this.el).getPropertyValue(this.options.styleValueContentSize),
            // styleValueBlockGap = window.getComputedStyle(this.el).getPropertyValue(this.options.styleValueBlockGap),
        ;

        return (windowSize - contentSize) / 2 > containerSize;
    }
}

export default Sidebar;
